import React from 'react';
import styled from "styled-components";
import moment from "moment";
import {FoodPlannerWeekday} from "./FoodPlannerWeekday";
import {useMediaQuery} from "../../../hooks/useMediaQuery";

const Container = styled.div`
    display: flex;
    background: white;
    align-content: center;
    margin: 0 0 8px;
`

function FoodPlannerCard(props) {
    const isMobile = useMediaQuery('(max-width: 767px)');

    if (isMobile) {
        return <Container>
            <FoodPlannerWeekday key={0} plannedFood={props.plannedFood[0]}
                                 ingredients={props.ingredients} recipes={props.recipes}
                                    index={"0"}
                                    date={moment.utc(props.date)}
                                    stats={props.stats[0]}/>
        </Container>
    }

    return <Container>
        {[0, 1, 2, 3, 4, 5, 6].map((id, index) => {
            let date = moment.utc(props.date).add(id, "days")

            return <FoodPlannerWeekday key={id} plannedFood={props.plannedFood[id]}
                                       ingredients={props.ingredients} recipes={props.recipes}
                                       index={index.toString()}
                                       date={date} stats={props.stats[id]}/>
        })}
    </Container>;
}

export default FoodPlannerCard